module.exports = __webpack_public_path__ + "img/broccoli-desktop.c9798501.png";